const VideoCard = (props) => {
    const handleOnClick = () => {
        window.open(`${props.url}`, '_blank');
        localStorage.setItem("currentProductName", props.title);
    };

    const lastUrl=props.url.split('/')
    const urlLocation=lastUrl[lastUrl.length-1]
    const handledLocation=urlLocation.split('=')
    const imageInformation=handledLocation[handledLocation.length-1]

    return (
        <>
            <div
                className="w-[400px] h-[270px] flex flex-col mb-[20px] mr-[5px] justify-center items-center text-[20px] hover:bg-stone-300 "
                onClick={() => handleOnClick()}
            >
                <img className="w-[390px] h-[200px] mb-[10px] border-solid border-[1px]" src={`https://img.youtube.com/vi/${imageInformation}/0.jpg`} />
                {props.title}
            </div>
        </>
    );
};
export default VideoCard;
